import { ButtonProps, useTheme } from '@chakra-ui/react'
import React, { FC } from 'react'

import { BasicComponentProps } from '../../../common/types'
import { NucbaTheme } from '../../../styles'
import Button from '../Primary/Button'

const ButtonSecondary: FC<BasicComponentProps<ButtonProps>> = ({
  children,
  ...rest
}) => {
  const { colors } = useTheme<NucbaTheme>()

  return (
    <Button
      borderRadius={30}
      bg={colors.nucba.gray}
      _hover={{ bg: colors.nucba.grayHover }}
      _active={{ bg: colors.nucba.grayHover }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default ButtonSecondary
